import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-pause",
  "use": "icon-si-glyph-pause-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-pause\" id=\"icon-si-glyph-pause\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1229</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\">\n            <path d=\"M0.002,1 C0.002,0.447 0.446,0 0.995,0 L4.967,0 C5.516,0 5.96,0.447 5.96,1 L5.96,15 C5.96,15.553 5.516,16 4.967,16 L0.995,16 C0.446,16 0.002,15.553 0.002,15 L0.002,1 L0.002,1 Z\" class=\"si-glyph-fill\" />\n            <path d=\"M8.002,1 C8.002,0.447 8.446,0 8.995,0 L12.967,0 C13.516,0 13.96,0.447 13.96,1 L13.96,15 C13.96,15.553 13.516,16 12.967,16 L8.995,16 C8.446,16 8.002,15.553 8.002,15 L8.002,1 L8.002,1 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-pause.svg
// module id = GEE+
// module chunks = 62